import { BIOMETRIC_DEVICE_TYPES } from '@/constants/device';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { SupportedDevicesIcon } from '../Common/Icons';
import './Wellness.less';
import WellnessListItem from './WellnessListItem';

// dayjs.extend(utc);

// const LocalTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const WellnessList = ({
  showViewHistoryModal,
  // showSupportDeviceModal,
  mappedData,
  loading,
  // timeZone,
  // setDateHandler,
  // allDeviceModels,
  getTranslatedLabel,
  selectedCard,
  isModalOpen,
  handleSupportedDevicesClick,
}) => {
  const trans = useSelector(translator);
  const [wellnessListData, setWellnessListData] = useState([]);
  // const [selectedDate, setSelectedDate] = useState(new Date());
  // const userTimezone = timeZone ? timeZone?.split(' ')[0] : LocalTimezone;
  const [wellnessTotalCount, setWellnessTotalCount] = useState(0);

  useEffect(() => {
    // if (loading === false && allDeviceModels && Object.keys(allDeviceModels).length > 0) {
    if (loading === false) {
      const WellnessListData = [];
      // const allDeviceTypes = Object.keys(allDeviceModels);
      const allDeviceTypes = Object.values(BIOMETRIC_DEVICE_TYPES);

      allDeviceTypes.forEach((item) => {
        const accessory = mappedData?.medical_accessories?.[item];
        if (accessory) {
          const listObj = {
            title: item,
            day: accessory?.day || '-',
            timeDifference: accessory?.timeDiff || '-',
            time: accessory?.time || '-',
            data: accessory?.data || '-',
            device: trans('DEVICE_USED_L'),
            deviceBrand: accessory?.deviceManufacture || '-',
            deviceModel: accessory?.deviceModel || '-',
            deviceuuid: accessory?.device_uuid || '-',
            eventName: accessory?.eventName || '-',
          };
          WellnessListData.push(listObj);
        }
      });

      // Sort alphabetically: first by device type (title), then by manufacturer (deviceBrand), then by model (deviceModel)
      WellnessListData.sort((a, b) => {
        // First sort by title (device type)
        const titleCompare = (a.title || '').localeCompare(b.title || '');
        if (titleCompare !== 0) return titleCompare;

        // Then sort by deviceBrand (manufacturer)
        const brandCompare = (a.deviceBrand || '').localeCompare(b.deviceBrand || '');
        if (brandCompare !== 0) return brandCompare;

        // Finally sort by deviceModel
        return (a.deviceModel || '').localeCompare(b.deviceModel || '');
      });

      setWellnessListData(WellnessListData);
      setWellnessTotalCount(WellnessListData.length);
    }
  }, [mappedData, loading, trans]);

  // const handleDateSelect = (date) => {
  //   if (!date || !date.isValid()) {
  //     console.error('Invalid date passed to handleDateSelect:', date);
  //     return;
  //   }
  //   const selectedDate = date.startOf('day').toDate(); // Convert dayjs to Date
  //   setSelectedDate(selectedDate);

  //   const startDateTime = date.startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  //   const endDateTime = date.endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  //   setDateHandler(startDateTime, endDateTime); // Pass formatted strings
  // };

  // const disabledFutureDate = (current) => {
  //   return current && current > moment().endOf('day');
  // };

  return (
    <>
      <>
        <div className="wellness-count">
          <div className="wellness-count-title">
            <label>
              {trans('TOTAL')} ({wellnessTotalCount})
            </label>
          </div>
          <div className="wellness-actions">
            <div
              className="supported-devices-action-container"
              onClick={handleSupportedDevicesClick}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleSupportedDevicesClick();
                }
              }}
              role="button"
              tabIndex={0}
            >
              <SupportedDevicesIcon />
              <div className="supported-devices-title">{trans('SUPPORTED_DEVICES_L')}</div>
            </div>
            {/* <SingleDatePicker
                            DateFormat={DateFormat}
                            timeZone={userTimezone}
                            defaultValue={selectedDate}
                            onDateSelect={handleDateSelect}
                            disabledDate={disabledFutureDate}
                            value={selectedDate ? dayjs(selectedDate).tz(userTimezone, true) : null}
                        /> */}
          </div>
        </div>
        {loading ? (
          <Spin
            spinning={loading}
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '20rem',
            }}
          />
        ) : (
          <div className="wellness-list-container">
            {wellnessListData.length > 0 ? (
              wellnessListData.map((item, index) => (
                <WellnessListItem
                  key={index}
                  showViewHistoryModal={showViewHistoryModal}
                  title={item.title}
                  day={item.day}
                  timeDifference={item.timeDifference}
                  time={item.time}
                  data={item.data}
                  device={item.device}
                  deviceBrand={item.deviceBrand}
                  deviceModel={item.deviceModel}
                  deviceuuid={item.deviceuuid}
                  eventName={item.eventName}
                  showViewHistory={true}
                  hasData={true}
                  getTranslatedLabel={getTranslatedLabel}
                  formattedDate={item.formattedDate}
                  isSelected={
                    isModalOpen &&
                    selectedCard === `${item.title}-${item.deviceBrand}-${item.deviceModel}`
                  }
                />
              ))
            ) : (
              <div className="wellness-item-no-data-message">
                <span className="wellness-item-no-data-label1">{trans('NO_PAIREDDEVICES_L')}</span>
                <span className="wellness-item-no-data-label2">
                  {trans('ONCEADEVICEHASBEENPAIREDITWILLAPPEARHERE')}
                </span>
              </div>
            )}
          </div>
        )}
      </>
    </>
  );
};

WellnessList.propTypes = {
  showViewHistoryModal: PropTypes.func,
  mappedData: PropTypes.object,
  loading: PropTypes.bool,
  // timeZone: PropTypes.string,
  // setDateHandler: PropTypes.func,
  selectedCard: PropTypes.string,
  isModalOpen: PropTypes.bool,
  getTranslatedLabel: PropTypes.func,
  handleSupportedDevicesClick: PropTypes.func,
};

export default WellnessList;
